import type { MediaThumbnailProps } from '@frameio/vapor';
import type { AssetThumbnailFragment } from '../gql/generated/AssetThumbnail';

/**
 * The getThumb function builds the media object that is consumed by MediaThumbnail
 * based on the asset typename. Excludes the thumb scrub information which is only
 * fetched after settled hydration.
 *
 * @param data The AssetThumbnailFragment instance
 * @returns media The partially constructed media object for MediaThumbnail
 */
export function getThumbMedia(
  asset: AssetThumbnailFragment
): MediaThumbnailProps['media'] {
  if (asset.__typename === 'VideoAsset' || asset.__typename === 'ModelAsset') {
    const thumbnailUrl = asset.thumbnailImageUrl?.url ?? '';

    return {
      thumbs: {
        thumb: thumbnailUrl,
        thumb2: thumbnailUrl,
      },
    };
  }

  let streamUrl = '';
  let metadata;

  switch (asset?.__typename) {
    case 'AudioAsset':
      streamUrl = asset.thumbnailImageUrl?.url ?? '';
      break;
    case 'DocumentAsset':
      streamUrl = asset.thumbnailImageUrl?.url ?? '';
      break;
    case 'ImageAsset':
      streamUrl = asset.thumbnailImageUrl?.url ?? '';
      metadata = {
        hasAlpha: asset.media?.metadata?.hasAlpha ?? false,
        originalHeight: asset.media?.metadata?.originalHeight ?? undefined,
        originalWidth: asset.media?.metadata?.originalWidth ?? undefined,
      };
      break;
    case 'InteractiveAsset':
    case 'InteractiveLiveAsset':
      streamUrl = asset.thumbnailImageUrl?.url ?? '';
      break;
    default:
      break;
  }

  return {
    thumbs: {
      thumb: streamUrl,
      thumb2: streamUrl,
    },
    metadata,
  };
}
